<template>
  <CModal :title="title"
          color="danger"
          :show="show"
          :centered="true"
          class="error-modal"
          @update:show="handleClose">

    <div>
      <div v-if="errors.length" class="my-3">
        <div v-for="(error, index) in errors" :key="`error-${index}`" class="text-error">
          {{ error }}
        </div>
      </div>
    </div>

    <template #footer>
      <CButton @click="handleClose" color="secondary">Close</CButton>
    </template>

  </CModal>
</template>

<script>

export default {
  name: 'error-modal',

  props: {
    show: {
      type: Boolean,
      default: false,
    },

    title: {
      type: String,
      default: 'Error',
    },

    errors: {
      type: Array,
      default: () => ([]),
    },
  },

  methods: {
    handleClose() {
      this.$emit('update:show', false);
    },
  },
}
</script>


<style scoped lang="scss">
.error-modal {
  .modal-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .fa-cog {
      color: #adadad;
    }
  }
}
</style>
